import React from "react";
import { SelectArrowIcon } from "../userManagement/Icons/SelectArrowIcon";

interface SelectArrowProps {
  className?: string;
}

export const SelectArrow = ({ className }: SelectArrowProps) => (
  <SelectArrowIcon className={className} />
);
